var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.1765,
    height: 27,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3001 18.7953H8V15.396L16.8939 6.23457C17.0397 6.08438 17.2375 6 17.4438 6C17.65 6 17.8478 6.08438 17.9937 6.23457L20.194 8.50028C20.2663 8.57469 20.3237 8.66305 20.3628 8.76031C20.402 8.85757 20.4221 8.96182 20.4221 9.06711C20.4221 9.17239 20.402 9.27665 20.3628 9.37391C20.3237 9.47117 20.2663 9.55953 20.194 9.63394L11.3001 18.7953ZM8 20.3977H22V22H8V20.3977Z",
    fill: "#2E8056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInvoiceIcon);
export default __webpack_public_path__ + "static/media/editInvoiceIcon.16538d3f8d22f04a10ab2e8543fe9c51.svg";
export { ForwardRef as ReactComponent };